import { CmsPagesQueryObject } from 'lib/core/services/magento/queries/getCmsPages'

export const getCmsPages = {
  processor: (getCmsPages: any, data: CmsPagesQueryObject) => {
    getCmsPages.items.metaTitle = data.getCmsPages.items.meta_title
  }
}
